import { gsap } from 'gsap';
// import { initGrid } from './utils/dom.js';
import { initBarba } from './utils/barba.js';

// Support for back/forward cache (bfcache)
window.addEventListener('pageshow', (event) => {
	if (event.persisted) {
		initBarba();
	}
});


// Clean up before page goes into bfcache
window.addEventListener('pagehide', (event) => {
	if (event.persisted) {
		gsap.globalTimeline.clear();
		gsap.killTweensOf('*');
	}
});


window.addEventListener('DOMContentLoaded', () =>{
	document.addEventListener('readystatechange', () => {
		if (document.readyState === "complete") {
			initBarba();
			// initGrid();
			
		}
	});
	document.addEventListener('dblclick', (e) => e.preventDefault());
	document.addEventListener('contextmenu', (e) => e.preventDefault());
});